import { storage } from '@otto-ec/global-resources/storage';

export type ComparisonPreferences = {
    closeBanner(): void;
    isBannerClosed(): boolean;
    readEnabled(): boolean;
    writeEnabled(enabled: boolean): void;
};

const BANNER_CLOSED_KEY = 'reptile_banner_closed';
const SHOW_COMPARISON_KEY = 'reptile_show_comparison';

export function createComparisonPreferences(sessionStorage: Storage = window.sessionStorage): ComparisonPreferences {
    const preferences = storage(sessionStorage);
    return {
        closeBanner: () => preferences.setItem(BANNER_CLOSED_KEY, 'true'),
        isBannerClosed: () => preferences.getItem(BANNER_CLOSED_KEY) === 'true',
        readEnabled: () => preferences.getItem(SHOW_COMPARISON_KEY) === 'true',
        writeEnabled: (enabled) => preferences.setItem(SHOW_COMPARISON_KEY, String(enabled)),
    };
}
